import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { formatNumber } from 'utils/numbers'

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 5,
  alignItems: 'center',
}))

const Label = styled('div')(({ color }) => ({
  padding: '1px 4px',
  borderRadius: '20px',
  textTransform: 'uppercase',
  fontWeight: 600,
  color: color.text,
  background: color.background,
  fontSize: 14,
}))

const Value = styled('div')(({ color }) => ({
  color: color.text,
  fontSize: 15,
}))

export const LBCPoints = ({ value }) => {
  const { i18n } = useTranslation()
  const color = useMemo(() => {
    if (value === 0) {
      return {
        text: '#2e3a59',
      }
    }

    if (value < 0) {
      return {
        text: '#e92833',
        background: '#fbf1f0',
      }
    }

    return {
      text: '#f7b63b',
    }
  }, [value])

  return (
    <Container>
      <Label color={color}>LBC</Label>
      <Value color={color}>{formatNumber(value, i18n.language)}</Value>
    </Container>
  )
}
